import React from "react";
import { safeLocalFormat } from "../../../utilities/functions";

const EndShiftDate = ({ row }) => {
  return <div>{row.endShift ? safeLocalFormat(row?.endShift) : "-"}</div>;
};

export default EndShiftDate;
